// extracted by mini-css-extract-plugin
export default {"wrapper":"BadgeLevelsTypeCell_wrapper__7OINt"};